import React, { Component }from 'react';
import { PanelGroup } from 'react-bootstrap';

class AccordionGroup extends Component {

    handleSelect = (activeKey) => {
        this.props.onSelect(activeKey);
    }

    render() {
        const { childs, activeKey, withoutLateralMenu } = this.props;

        return (
            <PanelGroup 
                accordion 
                id="accordion" 
                className={withoutLateralMenu? 'accordion-group-99' : 'accordion-group-456'}
                activeKey={activeKey}
                onSelect={this.handleSelect}
                >
                {childs}
            </PanelGroup>
        );
    }
}

export default AccordionGroup;
